export default __webpack_public_path__ + "static/media/MAR.a9b02f24.svg";